module.exports = __webpack_public_path__ + "static/img/DSCF1972.91c901f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSCF1972.jpg
// module id = Gkut
// module chunks = 0